var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAiLogo = function SvgAiLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#9768FF",
    opacity: 0.1,
    cx: 37,
    cy: 37,
    r: 37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.56 52.2c7.6 0 10.64-3.04 10.64-10.64v-9.12c0-7.6-3.04-10.64-10.64-10.64h-9.12c-7.6 0-10.64 3.04-10.64 10.64v9.12c0 7.6 3.04 10.64 10.64 10.64h9.12z",
    stroke: "#9768FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Inter-SemiBold, Inter",
    fontSize: 15,
    fontWeight: 500,
    fill: "#9768FF",
    transform: "translate(18 18)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11.611,
    y: 24.028
  }, "AI")), /*#__PURE__*/React.createElement("path", {
    stroke: "#9768FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    d: "M29.419 21.8V18M37 21.8V18M44.6 21.8V18M52.2 29.4H56M52.2 37H56M52.2 44.6H56M44.6 52.2V56M37.019 52.2V56M29.419 52.2V56M18 29.4h3.8M18 37h3.8M18 44.6h3.8"
  }))));
};
export default SvgAiLogo;